import { render, staticRenderFns } from "./CompIndustWaste.vue?vue&type=template&id=30367c11&scoped=true"
import script from "./CompIndustWaste.vue?vue&type=script&lang=js"
export * from "./CompIndustWaste.vue?vue&type=script&lang=js"
import style0 from "./CompIndustWaste.vue?vue&type=style&index=0&id=30367c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30367c11",
  null
  
)

export default component.exports